<template>
  <div class="tpl">
    <van-nav-bar title="亿家一家" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <img class="thumbnail" :src="GLOBAL.IMG + item.thumbnail" />
    <div class="price">
      ¥
      <em>{{item.price}}</em>
    </div>
    <div class="title">{{item.post_title}}</div>
    <Recommend module="hui" :list="item.recommend_goods"></Recommend>
    <div class="detail" v-html="item.post_content"></div>
    <div style="height:50px"></div>
    <div class="bottom">
      <van-sku
        ref="sku"
        v-model="skuShow"
        :show-add-cart-btn="false"
        :sku="item.sku"
        :goods="item.goods"
        :goods-id="item.id"
        :quota="quota"
        :quota-used="quotaUsed"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
      />
      <van-goods-action style="padding-left:10px;">
        <van-count-down v-if="time>0" :time="time" format="  剩余：DD天HH时mm分ss秒" @finish="getDetail" />
        <div style="width:30px;"></div>
        <van-goods-action-icon
          v-if="item.is_collect"
          icon="star"
          text="取消收藏"
          v-on:click="shouCangCancle()"
          color="#ff5000"
        />
        <van-goods-action-icon
          v-if="!item.is_collect"
          icon="star"
          text="收藏"
          v-on:click="shouCang()"
        />
        <van-goods-action-button
          type="danger"
          :text="item.price+'单独购买'"
          color="-webkit-linear-gradient(left, rgb(13, 195, 195), rgb(9, 136, 136))"
          @click="buy"
        />
        <van-goods-action-button
          type="danger"
          :text="item.tprice+'元，立即开团'"
          color="linear-gradient(90deg,#0dc3c3,#098888)"
          @click="tuan"
        />
      </van-goods-action>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { GoodsAction, GoodsActionIcon, GoodsActionButton, Sku } from "vant";
import { CountDown } from "vant";
import { Popup } from "vant";
import wx_share from "../../common/wx_share.js";
import Recommend from "@/components/tuijian.vue";

Vue.use(Popup);
Vue.use(CountDown);
Vue.use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Sku);
export default {
  name: "goodsDetailHui",
  components: {
    Recommend
  },
  data() {
    return {
      id: this.$route.params.id,
      user: { token: "" },
      item: { sku: { tree: [], none_sku: true }, goods: {}, end_seconds: 0 },
      skuShow: false,

      messageConfig: {
        // 数据结构见下方文档
      },
      goodsId: "0",
      quota: 0,
      quotaUsed: 0,
      buyDetail: {
        goods_id: this.$route.params.id,
        num: 1,
        attr_json: { n1: "", n2: "", n3: "" },
        is_collect: 0
      },
      time: 0,
      buyShow: { disabled: true, msg: "" },
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push("/");
    },
    shouCang() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/add",
          { id: this.id, module: 2 },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 1;
          }
        });
    },
    shouCangCancle() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_user/collection/delete",
          { id: this.id, module: 2 },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.item.is_collect = 0;
          }
        });
    },
    
    onBuyClicked() {
      let sku = this.$refs.sku.getSkuData();
      this.buyDetail.num = sku.selectedNum;
      if (sku.selectedSkuComb.s1) {
        this.buyDetail.attr_json.n1 = sku.selectedSkuComb.s1;
      }
      if (sku.selectedSkuComb.s2) {
        this.buyDetail.attr_json.n2 = sku.selectedSkuComb.s2;
      }
      if (sku.selectedSkuComb.s3) {
        this.buyDetail.attr_json.n3 = sku.selectedSkuComb.s3;
      }
      localStorage.setItem("buyDetail", JSON.stringify(this.buyDetail));
      this.$router.push("/hui/createorder/" + this.id);
    },

    buy() {
      this.skuShow = true;
    },
    tuan(){
        this.skuShow = true;
    },
    getDetail() {
      this.slide = [];
      this.$http
        .get(this.GLOBAL.API + "/s_tuan/goods/detail", {
          params: { id: this.id },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data.thumbsnails) {
              this.slide.push({
                id: i,
                image: data.data.thumbsnails[i],
                url: "#",
              });
            }
            data.data.post_content = data.data.post_content.replace(
              /src="default/g,
              'width= 100% src="' + this.GLOBAL.IMG + "default"
            );
            data.data.post_content = data.data.post_content.replace(
              /src="groupshop/g,
              'width= 100% src="' + this.GLOBAL.IMG + "groupshop"
            );
            this.item = data.data;
            let info ={"post_title":this.item.post_title,"desc":this.item.post_title,"thumbnail":'http://yijia.sihandbms.cn/upload/'+this.item.thumbnail}
            wx_share.wx_share(this.GLOBAL.API,this.user,info);
          }
        });
    }
  },
  watch: {
    $route(to, from) {
      if (from.params.id) {
        //   this.$router.go(0);
        this.id = to.params.id;
        this.getDetail();
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.thumbnail {
  width: 100%;
  display: block;
}
.price {
  color: #f2270c;
  em {
    font-size: 30px;
    font-family: JDZH-Regular;
  }
  padding: 10px;
  background-color: #ffffff;
}
.title {
  font-size: 16px;
  color: #262626;
  font-weight: 700;
  padding: 10px;
  border-radius: 0 0 10px 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.detail {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;
}
</style>